<template>
    <span>{{data}}</span>
</template>
<script>
export default {
  data () {
    return {
      data: ''
    }
  },
  props: ['value'],
  watch: {
    value: 'handleValueChange'
  },
  methods: {
    timestampToData (timestamp) {
      function formatDate (now) {
        var year = now.getFullYear()
        var month = now.getMonth() + 1
        var date = now.getDate()
        var hour = now.getHours()
        var minute = now.getMinutes()
        var second = now.getSeconds()
        return (
          year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
        )
      }
      return formatDate(new Date(timestamp))
    },
    timeTrans (val) {
      if (val) {
        this.data = this.timestampToData(val)
      } else {
        this.data = ''
      }
    },
    handleValueChange (val, oldVal) {
      this.timeTrans(val)
    }
  },
  created () {
    this.timeTrans(this.value)
  }
}
</script>
